export var PLATFORMS = /*#__PURE__*/function (PLATFORMS) {
  PLATFORMS["NATIVE"] = "mobileNative";
  PLATFORMS["HYBRID"] = "mobileHybrid";
  PLATFORMS["WEB"] = "web";
  return PLATFORMS;
}({});
export var MODE = /*#__PURE__*/function (MODE) {
  MODE["RENDERER"] = "renderer";
  MODE["EDITOR"] = "editor";
  return MODE;
}({});
export var FULL_WIDTH_MODE = /*#__PURE__*/function (FULL_WIDTH_MODE) {
  FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
  FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
  return FULL_WIDTH_MODE;
}({});
export var BROWSER_FREEZE_INTERACTION_TYPE = /*#__PURE__*/function (BROWSER_FREEZE_INTERACTION_TYPE) {
  BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
  BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
  BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
  BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
  return BROWSER_FREEZE_INTERACTION_TYPE;
}({});